var path = '/Users/jakebuszynski/Documents/git/gitlab/enplug-projects/enplug.com/src/templates/checkout-flow/confirmation.directive.tpl.html';
var html = "<div class=w-container> <div class=confirmation-container> <div class=title>Congratulations! You've created your Enplug account.</div> <summary-directive selectedshippingrate=selectedshippingrate data=data laststep=laststep></summary-directive> <div class=checkout-multi-form> <section> <form class=checkout-form> <div class=form-row> <div class=call-to-actions> <input type=submit class=\"btn btn-primary\" value=\"LOG IN\" ng-click=gotoLoginPage()> </div> </div> </form> </section> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/templates/checkout-flow/confirmation.directive.tpl.html
// module id = 99
// module chunks = 0